/**
 * Input Group Label Component
 * Responsible for showing input level errors specific to a particular field
 *
 */
import { Component } from '@angular/core';

@Component({
  selector: 'td-wb-input-group-label',
  template: '<ng-content />',
  styleUrls: ['input-group-label.component.scss']
})
export class InputGroupLabelComponent {
}
